<div class="inventory-modal">
    <div class="inventory-modal__header">
        <!--Edit Serial Number-->

        <div class="text-block">
            <div class="row">
                <div class="col-sm-4"><span class="inventory-modal__title">Action History</span></div>
               
            </div>
            <table class="table table--full-width table--striped">
                <thead>
                    <tr>
                        <th>{{'Component' | translate | async}}</th>
                        <th>{{'Date' | translate | async}}</th>
                        <th>{{'Action Taken' | translate | async}}</th>
                        <th>{{'Comment' | translate | async}}</th>
                        <!-- <th>{{'Cost' | translate | async}}</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let history of componentHistories">
                        <td>{{history.ComponentName}}</td>
                        <td>{{history.ActionDate | date : 'dd-MMM-yyyy'}}</td>
                        <td>{{history.ActionName}}</td>
                        <td>{{history.Comment}}</td>
                        <!-- <td>{{history.Cost | currency }}</td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>